import { observer } from 'mobx-react-lite';
import { FC, useCallback } from 'react';

import { MemberDevice } from '@gem/call/CallStore/Member/MemberDevice';
import { List } from '@gem/call/Removable/components/List/List';

import { MemberCard } from './MemberCard/MemberCard';
import { useMemberListPresenter } from './MemberList.presenter';
import styles from './MemberList.styles.m.css';

export const MemberList: FC = observer(() => {
  const presenter = useMemberListPresenter();

  const renderItem = useCallback(
    (memberDevice: MemberDevice) => <MemberCard memberDevice={memberDevice} />,
    []
  );

  return (
    <div className={styles.container}>
      <List
        data={presenter.memberDevices}
        keyExtractor={presenter.keyExtractor}
        renderItem={renderItem}
      />
    </div>
  );
});
